import { TFormalOffer } from './formalOffers.types';
import { getDurationInMonths } from '../GetDurationInMonths/getDurationInMonths';

export const getIsMicroOffer = (formalOffer: TFormalOffer): boolean => {
    return getDurationInMonths(formalOffer.duration!) < 12;
};
